import React, { Component } from 'react';
import EventBus from 'eventing-bus';
import { ACTION_TYPES, IMAGES } from 'src/constants';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import queryString from 'query-string';
import { Convert } from 'src/helpers';
import { Screen, Loader } from 'src/components';
import MobileOneTimeTransactions from './mobileOneTimeTransactions';
import DesktopOneTimeTransactions from './desktopOneTimeTransactions';
import OneTimeTransactionsSuccess from '../oneTimeTransactionsSuccess';
import styles from './_oneTimeTransactions.module.scss';

const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;
const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';
const API_ENDPOINT_URL = IS_PRODUCTION
  ? 'https://api.savvyapp.in'
  : 'https://surface.thesavvyapp.in';

class OneTimeTransactions extends Component {
  state = {
    amount: '',
    minAmount: '',
    isLoading: false,
    isSubmit: false,
  };

  componentDidMount() {
    this.requestPaymentSubscription = EventBus.on(
      ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT,
      () => this.setState({ isLoading: true }),
    );
    this.paymentSubscriptionSuccess = EventBus.on(
      ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SUCCESS,
      this.onPaymentGenerated,
    );
    this.paymentSubscriptionFailure = EventBus.on(
      ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_FAILED,
      () => this.setState({ isLoading: false }),
    );

    this.requestCheckoutDetail = EventBus.on(ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_REQUEST, () =>
      this.setState({ isLoading: true }),
    );
    this.checkoutDetailSuccess = EventBus.on(
      ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_SUCCESS,
      this.onCheckoutDetailFetched,
    );
    this.checkoutDetailFailure = EventBus.on(ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_FAILED, () =>
      this.setState({ isLoading: false }),
    );

    // this.props.requestCheckoutDetail('5bda344f-24a1-4e55-8b2d-2e99a370fe1f');

    let { uuid, partnerAccessKey } = queryString.parse(this.props.location.search);

    if (uuid && partnerAccessKey) {
      this.props.requestCheckoutDetail({
        uuid,
        headers: {
          'X-PARTNER-ACCESS-KEY': partnerAccessKey,
        },
      });
    }
  }

  componentWillUnmount() {
    this.requestPaymentSubscription();
    this.paymentSubscriptionSuccess();
    this.paymentSubscriptionFailure();

    this.requestCheckoutDetail();
    this.checkoutDetailSuccess();
    this.checkoutDetailFailure();
  }

  onCheckoutDetailFetched = (data) => {
    const { history } = this.props;
    const url = document.location.pathname + document.location.search;
    let { reason, ...restParams } = queryString.parse(this.props.location.search);
    const status = restParams['?status'];

    if (data?.oneClickCheckout?.depositStatus === 'error' && !status) {
      history.push(`${url}&?status=failure`);
    } else if (data?.oneClickCheckout?.depositStatus !== 'created' && !status) {
      history.push(`${url}&?status=success`);
    }
    this.setState({
      isLoading: false,
      amount: data?.oneClickCheckout?.amount || '',
      minAmount: data?.oneClickCheckout?.minAmount || '',
    });
  };

  handleAmountChange = (event) => {
    this.setState({ amount: event.target.value });
  };

  handleOnSubmit = () => {
    this.setState({ isSubmit: true }, () => {
      const errors = this.handleValidations();
      if (errors?.isError) return;
      const { amount } = this.state;
      const { href } = document.location;

      let { uuid, partnerAccessKey } = queryString.parse(this.props.location.search);

      this.props.requestGenerateCheckoutPayment({
        body: {
          one_click_checkout: {
            amount: +amount,
            payment_redirect_url: `${href}&`,
          },
        },
        uuid,
        headers: {
          'X-PARTNER-ACCESS-KEY': partnerAccessKey,
        },
      });
    });
  };

  onPaymentGenerated = (data) => {
    const { name, depositRequestId, fundName, partner } = data?.oneClickCheckout || '';
    const amount = Number(data?.oneClickCheckout.amount) * 100; // send it as cents ex: 100Rs as 10000 cents
    let options = {
      key: RAZORPAY_KEY,
      amount,
      currency: 'INR',
      name,
      description: fundName,
      order_id: depositRequestId,
      image: partner?.logo || IMAGES.MOTILAL_OSWAL,
      prefill: {
        name,
      },
      theme: {
        color: '#ffd401',
      },
    };

    const isLocal = document.location.hostname === 'localhost';
    if (isLocal) {
      options = {
        ...options,
        handler: () => {
          this.props.history.push(
            `/transaction/one-time${document.location.search}&?status=success`,
          );
        },
      };
    } else {
      options = {
        ...options,
        callback_url: `${API_ENDPOINT_URL}/deposits/razorpay_redirect`,
      };
    }

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    this.setState({ isLoading: false });
  };

  handleValidations = () => {
    const { isSubmit, amount, minAmount } = this.state;
    let errorStructure = {
      e_amount: '',
      isError: false,
    };
    if (!isSubmit) return errorStructure;
    if (!amount) {
      errorStructure = { ...errorStructure, e_amount: 'Please enter amount', isError: true };
    } else if (amount < minAmount) {
      errorStructure = {
        ...errorStructure,
        e_amount: `Amount must be greater than or equal to ${Convert.toCurrencyValue(minAmount)}`,
        isError: true,
      };
    }
    return errorStructure;
  };

  render() {
    const errors = this.handleValidations();
    const { checkout } = this.props;
    const { isLoading } = this.state;
    const checkoutDetail = checkout?.checkoutDetail || {};
    let { reason, ...restParams } = queryString.parse(this.props.location.search);
    const status = restParams['?status'];

    return (
      <>
        {status ? (
          <OneTimeTransactionsSuccess status={status} reason={reason} />
        ) : (
          <Screen>
            <div className={cx(styles['sip-transactions'])}>
              <div className={styles['mobile']}>
                <MobileOneTimeTransactions
                  {...this.state}
                  errors={errors}
                  handleAmountChange={this.handleAmountChange}
                  handleOnSubmit={this.handleOnSubmit}
                  checkoutDetail={checkoutDetail}
                />
              </div>
              <div className={styles['desktop']}>
                <DesktopOneTimeTransactions
                  {...this.state}
                  errors={errors}
                  handleAmountChange={this.handleAmountChange}
                  handleOnSubmit={this.handleOnSubmit}
                  checkoutDetail={checkoutDetail}
                />
              </div>
            </div>
          </Screen>
        )}
        <Loader loading={isLoading} />
      </>
    );
  }
}

export default withRouter(OneTimeTransactions);
